import React, { Component } from 'react';
import '../styles/ResultBookList.css';
import ResultBook from './ResultBook';

class ResultBookList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recommendations: [],
    }
    this.createRecommendations();
  }

  removeDuplicates = async (sortedRecommendations) => {
    let uniqueTitles = {};
    let uniqueRecommendations = [];
    const length = sortedRecommendations.length;
    let uniqIndex = 0;
    for(let i = 0; i < length; i++) {
          let book = sortedRecommendations[i];
          
          if(uniqueTitles[book.title] !== 1) {
            uniqueTitles[book.title] = 1;
            book.rank = uniqIndex+1;
            uniqueRecommendations[uniqIndex++] = book;
          }
    }
    return uniqueRecommendations;
  }

  createRecommendations = async () => {
    //SORT
    let sortedRecommendations = [...this.props.recommendations];
    await sortedRecommendations.sort((a, b) => {
      if (a.tier === b.tier) return b.score - a.score;
      return a.tier - b.tier;
    })
    //REMOVE DUPLICATES
    let uniqueRecommendations = await this.removeDuplicates(sortedRecommendations);
    this.setState({recommendations: uniqueRecommendations});
    // console.log(uniqueRecommendations);
  }

  renderBooks = () => {
    return this.state.recommendations.map((book) => {
      return <ResultBook book={book} key={book._id}/>
    })
  }
  
  render() {
    return (
      <div className="ResultBookList">
        {this.renderBooks()}
      </div>
    )
  }
}

export default ResultBookList;


// WEBPACK FOOTER //
// ./src/components/ResultBookList.js